<template>
  <div class="StampList">
    <div class="header">Curated Recommendations by Experts</div>

    <div class="flex stamp-outer">
      <div v-for="stamp in stampList" class="flex-center stamp-cards desktop" @click="goToExpertView(stamp.name)">
        <div class="flex first-section">
          <img class="icon" :src="stamp.icon" alt="" />
          <p class="stamp-title">{{ stamp.name }}</p>
        </div>

        <img class="arrow" src="../assets/images/rightArrow.svg" alt="" />
      </div>

      <div v-for="stamp in stampList" class="stamp-cards mobile" @click="goToExpertView(stamp.name)">
        <div class="flex first-section">
          <img class="icon" :src="stamp.icon" alt="" />
          <img class="arrow" src="../assets/images/rightArrow.svg" alt="" />
        </div>
        <p class="stamp-title">{{ stamp.name }}</p>
      </div>
    </div>
  </div>
</template>
  
  <script>
export default {
  name: 'StampList',
  mixins: [],
  props: ['stampList'],
  components: {},

  data() {
    return {};
  },

  created() {},

  mounted() {},

  beforeRouteEnter(to, from, next) {},

  methods: {
    goToExpertView(stamp) {
      this.$router.push(`/experts-past-recommendations?stamp=${stamp}`);
    },
  },

  beforeDestroy() {},

  computed: {},
};
</script>
  
  <style lang="scss" scoped>
.StampList {
  .header {
    display: flex;
    justify-content: space-between;
    font-size: 15px;
    font-weight: 700;
    margin-bottom: 0px;
    width: calc(100% - 10px);
  }
  .mobile {
    display: none;
  }
  .stamp-outer {
    display: flex;
    // justify-content: space-between;
    flex-wrap: wrap;
  }
  .stamp-cards {
    padding: 10px;
    font-size: 12px;
    font-weight: 500;
    background-color: #ffff;
    border-radius: 10px;
    margin-right: 12px;
    margin-top: 10px;
    height: 30px;
    cursor: pointer;

    .stamp-title {
      font-size: 12px;
      font-weight: 500;
    }
    .icon {
      width: 28px;
      margin-right: 10px;
    }
    .arrow {
      width: 20px;
    }
  }

  @media screen and (max-width: 1283px) {
    .stamp-outer {
      justify-content: space-between;
    }
    .stamp-cards {
      height: 80px;
      width: 26%;
      .first-section {
        display: unset;
        width: 60%;
        p {
          margin: 0;
          margin-top: 10px;
        }
      }
      .icon {
        width: 40px;
      }
      .arrow {
        position: relative;
        top: -15px;
        right: -5px;
        width: 22px;
      }
      // p {
      //   font-size: 10px;
      // }
    }
  }
  @media screen and (max-width: 600px) {
    .mobile {
      display: block;
    }
    .desktop {
      display: none;
    }
    .stamp-cards {
      width: 24%;
      padding: 15px;
      height: 60px;
      .first-section {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        height: 30px;
      }
      .arrow {
        position: unset;
        width: 18px;
      }
      .stamp-title {
        font-size: 10px;
        font-weight: 600;
      }
    }
  }

  @media screen and (max-width: 470px) {
    .stamp-outer {
      width: auto;
    }
    .stamp-cards {
      // width: 22%;
      padding: 10px 8px;
      .icon {
        width: 25px;
      }
      .first-section {
        height: 25px;
      }
    }
  }
}
</style>